module.exports = __webpack_public_path__ + "assets/img/sy-1.c05da820.png";